import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

export default function WhatsAppFloat() {
  const { t } = useLang();
  const [showBubble, setShowBubble] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowBubble(true), 4000);
    return () => clearTimeout(timer);
  }, []);

  const url = `https://wa.me/447365373821?text=${encodeURIComponent(t.whatsapp.message)}`;

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
      <AnimatePresence>
        {showBubble && !dismissed && (
          <motion.div
            initial={{ opacity: 0, y: 14, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 8, scale: 0.95 }}
            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            className="relative rounded-2xl rounded-br-sm bg-[#1B1E25] border border-white/10 shadow-[0_12px_32px_rgba(0,0,0,0.5)] px-4 py-3 max-w-[250px]"
            dir="auto"
            data-testid="whatsapp-greeting-bubble"
          >
            <button
              onClick={() => setDismissed(true)}
              aria-label="Kapat"
              className="absolute -top-2 -left-2 w-6 h-6 rounded-full bg-[#262B34] border border-white/10 text-slate-400 hover:text-white flex items-center justify-center transition-colors"
              data-testid="whatsapp-bubble-close"
            >
              <X size={12} />
            </button>
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="block text-sm text-white leading-snug hover:text-[#5B7FFF] transition-colors"
              data-testid="whatsapp-bubble-link"
            >
              <span className="block text-[11px] font-semibold text-[#25D366] mb-1">CDN Bilişim</span>
              {t.whatsapp.greeting}
            </a>
            <span className="absolute -bottom-1.5 right-5 w-3 h-3 rotate-45 bg-[#1B1E25] border-r border-b border-white/10" />
          </motion.div>
        )}
      </AnimatePresence>

      <motion.a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t.whatsapp.aria}
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 2, type: "spring", stiffness: 200 }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        className="whatsapp-pulse relative w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-[0_8px_24px_rgba(37,211,102,0.4)]"
        data-testid="whatsapp-float-button"
      >
        <svg viewBox="0 0 24 24" width="28" height="28" fill="#fff" className="relative z-10">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
        </svg>
      </motion.a>
    </div>
  );
}
